import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import "./HeroSection.css";
import appleImage from "../../assets/Apple.png";
import playStoreImage from "../../assets/PlayStore.png";
import CarImage from "../../assets/HeroCar.png";

export const HeroSection = () => {
  const textRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      textRef.current,
      { scale: 0.8 },
      { scale: 1, duration: 1.5, ease: "power2.out" }
    );

    gsap.fromTo(
      imageRef.current,
      { x: "100%", opacity: 0 },
      { x: "0%", opacity: 1, duration: 1.5, ease: "power2.out", delay: 0.5 }
    );
  }, []);

  return React.createElement(
    "main",
    null,
    // Text Section
    React.createElement(
      "section",
      { className: "text-section", ref: textRef },
      React.createElement(
        "h1",
        null,
        "Unleash Your Car’s Potential with ",
        React.createElement("span", null, " Premium Automotive Upgrades ")
      ),
      React.createElement(
        "p",
        null,
        "Unlock a world of premium automotive parts with Motatec Asia. Offering trusted high quality, unbeatable pricing"
      )
    ),
    // Image Section
    React.createElement(
      "section",
      { className: "hero-image-container" },
      React.createElement("div", { className: "orange-box" }),
      React.createElement("img", {
        ref: imageRef,
        src: CarImage,
        alt: "Car",
        className: "car-image",
      })
    )
  );
};
